(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(scrollbarConfig);

    scrollbarConfig.$inject = ['ScrollBarsProvider'];

    function scrollbarConfig(ScrollBarsProvider) {
        ScrollBarsProvider.defaults = {
            theme: 'minimal-dark',
            axis: 'y'
        };
    }
})();